module.exports = __webpack_public_path__ + "static/kitchen_2K-8ecc8c652d0e6c8031152f4b15fc5999.webp";